document.addEventListener("DOMContentLoaded", function () {
    function isMobileDesktopChartFullscreen() {
        return document.documentElement.classList.contains('desktop-portrait-accepted') &&
            (window.matchMedia('(any-pointer: coarse)').matches ||
                window.matchMedia('(pointer: coarse)').matches ||
                navigator.maxTouchPoints > 0);
    }

    function scheduleMobileSceneResize() {
        const resize = () => window.StockStormDesktopScale?.resizeScene?.();
        requestAnimationFrame(() => {
            requestAnimationFrame(resize);
        });
        [50, 200, 450, 800].forEach((delay) => {
            window.setTimeout(resize, delay);
        });
    }

    let mainChartScrollY = 0;
    let isMainChartScrollLocked = false;

    function setMainChartFullscreenScrollLock(lock) {
        if (!isMobileDesktopChartFullscreen()) {
            return;
        }
        if (lock) {
            if (isMainChartScrollLocked) {
                return;
            }
            mainChartScrollY = window.scrollY;
            document.documentElement.classList.add('desktop-chart-fullscreen-lock');
            document.body.style.position = 'fixed';
            document.body.style.top = `-${mainChartScrollY}px`;
            document.body.style.left = '0';
            document.body.style.right = '0';
            document.body.style.width = '100%';
            isMainChartScrollLocked = true;
            return;
        }
        if (!isMainChartScrollLocked) {
            return;
        }
        document.documentElement.classList.remove('desktop-chart-fullscreen-lock');
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.left = '';
        document.body.style.right = '';
        document.body.style.width = '';
        isMainChartScrollLocked = false;
        window.scrollTo(0, mainChartScrollY);
    }

    const fullscreenToggle = document.querySelector('#main-block .fullscreen-toggle');
    const titleAndDate = document.querySelector('#main-block .title-and-date');
    const fullscreenCaption = document.querySelector('.fullscreen-caption');


    if (fullscreenToggle) {
        const captionHeading = fullscreenCaption?.querySelector('h2');
        const captionDate = fullscreenCaption?.querySelector('p');

        const updateFullscreenCaption = (useLiveText = true) => {
            if (!titleAndDate || !fullscreenCaption) {
                return;
            }
            const titleText = titleAndDate.querySelector('h2')?.textContent?.trim() || '';
            const dateText = titleAndDate.querySelector('p')?.textContent?.trim() || '';
            captionHeading && (captionHeading.textContent = titleText);
            captionDate && (captionDate.textContent = dateText);
        };

        if (titleAndDate && fullscreenCaption) {
            const observer = new MutationObserver(updateFullscreenCaption);
            observer.observe(titleAndDate, { characterData: true, childList: true, subtree: true });
            updateFullscreenCaption();
        }

        const sceneWrapper = document.querySelector('#main-block .chart-wrapper');
        const fullscreenClass = 'chart-fullscreen';
        const transitionClass = 'chart-fullscreen-transition';
        let fallbackFullscreen = false;
        let transitionTimer;

        const resizeScene = (delay = 0) => {
            const performResize = () => {
                // Get A-Frame scene element
                const sceneEl = document.querySelector('#main-scene');
                if (sceneEl && sceneEl.resize) {
                    // Explicitly resize A-Frame scene
                    sceneEl.resize();
                }
                // Also dispatch window resize event for other listeners
                window.requestAnimationFrame(() => {
                    window.dispatchEvent(new Event('resize'));
                });
            };

            if (delay > 0) {
                setTimeout(performResize, delay);
            } else {
                performResize();
            }
        };

        const resizeAfterTransition = (delay = 750) => {
            const sceneEl = document.querySelector('#main-scene');
            const canvas = sceneEl?.querySelector('canvas');
            const mobile = isMobileDesktopChartFullscreen();
            const effectiveDelay = mobile ? 40 : delay;
            if (canvas && !mobile) {
                canvas.style.visibility = 'hidden';
            }
            setTimeout(() => {
                if (sceneEl?.resize) {
                    sceneEl.resize();
                }
                if (mobile) {
                    scheduleMobileSceneResize();
                }
                window.requestAnimationFrame(() => {
                    window.dispatchEvent(new Event('resize'));
                    window.requestAnimationFrame(() => {
                        if (canvas) {
                            canvas.style.visibility = '';
                            canvas.style.display = 'block';
                        }
                    });
                });
            }, effectiveDelay);
        };

        const applyFullscreenClass = (isActive) => {
            document.body.classList.toggle(fullscreenClass, isActive);
            fullscreenToggle.setAttribute('aria-pressed', isActive ? 'true' : 'false');


            const centerPanelContainer = document.querySelector('#center-panel-container');
            if (centerPanelContainer) {
                if (isActive) {
                    const actualPos = centerPanelContainer.object3D?.position;
                    if (actualPos) {
                        centerPanelContainer.dataset.originalPosition =
                            `${actualPos.x} ${actualPos.y} ${actualPos.z}`;
                        if (Math.abs(actualPos.x) > 0.01) {
                            centerPanelContainer.setAttribute(
                                'position',
                                `0 ${actualPos.y} ${actualPos.z}`
                            );
                        }
                    } else {
                        const currentPos = centerPanelContainer.getAttribute('position');
                        if (typeof currentPos === 'string') {
                            centerPanelContainer.dataset.originalPosition = currentPos;
                        } else if (currentPos && typeof currentPos === 'object') {
                            centerPanelContainer.dataset.originalPosition =
                                `${currentPos.x || 0} ${currentPos.y || 0} ${currentPos.z || 0}`;
                        } else {
                            centerPanelContainer.dataset.originalPosition = '0 2.7 -1.2';
                        }
                    }
                } else {
                    const originalPos = centerPanelContainer.dataset.originalPosition;
                    if (originalPos) {
                        centerPanelContainer.setAttribute('position', originalPos);
                    }
                    delete centerPanelContainer.dataset.originalPosition;
                }
            }
        };

        const enterFallback = () => {
            window.closeRightPanelLiveChartFullscreen?.();
            const rightWrapper = document.querySelector('.right-wrapper');
            if (rightWrapper) {
                rightWrapper.classList.remove('financials-expanded');
            }
            document.documentElement.classList.remove('desktop-right-chart-fullscreen');
            document.documentElement.classList.remove('desktop-right-chart-fullscreen-lock');
            fallbackFullscreen = true;
            setMainChartFullscreenScrollLock(true);
            applyFullscreenClass(true);
            resizeAfterTransition(750);
        };

        const exitFallback = () => {
            fallbackFullscreen = false;
            applyFullscreenClass(false);
            setMainChartFullscreenScrollLock(false);
            resizeAfterTransition(750);
        };

        window.StockStormMainChartFullscreen = {
            isActive: () => document.body.classList.contains(fullscreenClass) ||
                document.fullscreenElement === sceneWrapper,
            exit: () => {
                if (!document.body.classList.contains(fullscreenClass) && document.fullscreenElement !== sceneWrapper) {
                    return;
                }
                fallbackFullscreen = false;
                applyFullscreenClass(false);
                setMainChartFullscreenScrollLock(false);
                if (document.fullscreenElement === sceneWrapper) {
                    document.exitFullscreen().catch(() => {});
                }
            }
        };

        const enableTransition = () => {
            document.body.classList.add(transitionClass);
            clearTimeout(transitionTimer);
            transitionTimer = setTimeout(() => {
                document.body.classList.remove(transitionClass);
            }, 700);
        };

        const handleToggle = async (event) => {
            if (event?.target?.closest?.('.right-wrapper .full-screen')) {
                return;
            }

            enableTransition();

            if (isMobileDesktopChartFullscreen()) {
                if (fallbackFullscreen) {
                    exitFallback();
                } else {
                    enterFallback();
                }
                return;
            }

            if (document.fullscreenElement) {
                await document.exitFullscreen();
                return;
            }

            if (fallbackFullscreen) {
                exitFallback();
                return;
            }

            if (!sceneWrapper || !sceneWrapper.requestFullscreen) {
                enterFallback();
                return;
            }

            try {
                await sceneWrapper.requestFullscreen();
            } catch (error) {
                if (__LOG_ERROR__) AppLog.error('[Fullscreen] Error requesting fullscreen:', error);
                enterFallback();
            }
        };

        fullscreenToggle.addEventListener('click', handleToggle);

        document.addEventListener('fullscreenchange', () => {
            if (isMobileDesktopChartFullscreen()) {
                return;
            }
            const isSceneFullscreen = document.fullscreenElement === sceneWrapper;
            fallbackFullscreen = false;
            applyFullscreenClass(isSceneFullscreen);
            resizeAfterTransition(750);
        });

        document.addEventListener('keydown', (event) => {
            if (event.key === 'Escape') {
                enableTransition();
                if (fallbackFullscreen) {
                    exitFallback();
                    return;
                }
                if (document.fullscreenElement) {
                    document.exitFullscreen();
                    // resizeScene will be called by fullscreenchange event
                }
            }
        });

        const fullscreenClose = document.querySelector('#main-block .fullscreen-close');
        if (fullscreenClose) {
            fullscreenClose.addEventListener('click', () => {
                enableTransition();
                if (fallbackFullscreen) {
                    exitFallback();
                    return;
                }
                if (document.fullscreenElement) {
                    document.exitFullscreen();
                    // resizeScene will be called by fullscreenchange event
                }
            });
        }
    } else {
        if (__LOG_WARN__) AppLog.warn('[Fullscreen] fullscreenToggle button not found! Using event delegation fallback.');
        // Use event delegation as fallback
        document.addEventListener('click', (event) => {
            if (event.target.closest('#main-block .fullscreen-toggle')) {
                const sceneWrapper = document.querySelector('#main-block .chart-wrapper');
                const fullscreenClass = 'chart-fullscreen';
                const transitionClass = 'chart-fullscreen-transition';

                document.body.classList.add(transitionClass);
                setTimeout(() => {
                    document.body.classList.remove(transitionClass);
                }, 700);

                if (document.fullscreenElement) {
                    document.exitFullscreen();
                } else if (sceneWrapper && sceneWrapper.requestFullscreen) {
                    sceneWrapper.requestFullscreen().catch(error => {
                        if (__LOG_ERROR__) AppLog.error('[Fullscreen] Error:', error);
                        document.body.classList.add(fullscreenClass);
                    });
                } else {
                    document.body.classList.add(fullscreenClass);
                }
            }
        });

        // Also try to find it again after a delay (in case it's added dynamically)
        setTimeout(() => {
            const retryFullscreenToggle = document.querySelector('#main-block .fullscreen-toggle');
            if (retryFullscreenToggle) {
                const sceneWrapper = document.querySelector('#main-block .chart-wrapper');
                const fullscreenClass = 'chart-fullscreen';
                const transitionClass = 'chart-fullscreen-transition';
                let fallbackFullscreen = false;
                let transitionTimer;

                const resizeScene = (delay = 0) => {
                    const performResize = () => {
                        // Get A-Frame scene element
                        const sceneEl = document.querySelector('#main-scene');
                        if (sceneEl && sceneEl.resize) {
                            // Explicitly resize A-Frame scene
                            sceneEl.resize();
                        }
                        // Also dispatch window resize event for other listeners
                        window.requestAnimationFrame(() => {
                            window.dispatchEvent(new Event('resize'));
                        });
                    };

                    if (delay > 0) {
                        setTimeout(performResize, delay);
                    } else {
                        performResize();
                    }
                };

                const resizeAfterTransition = (delay = 750) => {
                    const sceneEl = document.querySelector('#main-scene');
                    const canvas = sceneEl?.querySelector('canvas');
                    if (canvas) canvas.style.visibility = 'hidden';
                    setTimeout(() => {
                        if (sceneEl?.resize) sceneEl.resize();
                        window.requestAnimationFrame(() => {
                            window.dispatchEvent(new Event('resize'));
                            window.requestAnimationFrame(() => {
                                if (canvas) canvas.style.visibility = '';
                            });
                        });
                    }, delay);
                };

                const applyFullscreenClass = (isActive) => {
                    document.body.classList.toggle(fullscreenClass, isActive);
                    retryFullscreenToggle.setAttribute('aria-pressed', isActive ? 'true' : 'false');
                };

                const enterFallback = () => {
                    window.closeRightPanelLiveChartFullscreen?.();
                    const rightWrapper = document.querySelector('.right-wrapper');
                    if (rightWrapper) {
                        rightWrapper.classList.remove('financials-expanded');
                    }
                    document.documentElement.classList.remove('desktop-right-chart-fullscreen');
                    document.documentElement.classList.remove('desktop-right-chart-fullscreen-lock');
                    fallbackFullscreen = true;
                    applyFullscreenClass(true);
                    resizeAfterTransition(750);
                };

                const exitFallback = () => {
                    fallbackFullscreen = false;
                    applyFullscreenClass(false);
                    resizeAfterTransition(750);
                };

                const enableTransition = () => {
                    document.body.classList.add(transitionClass);
                    clearTimeout(transitionTimer);
                    transitionTimer = setTimeout(() => {
                        document.body.classList.remove(transitionClass);
                    }, 700);
                };

                const handleToggle = async () => {
                    enableTransition();
                    if (document.fullscreenElement) {
                        await document.exitFullscreen();
                        return;
                    }

                    if (fallbackFullscreen) {
                        exitFallback();
                        return;
                    }

                    if (!sceneWrapper || !sceneWrapper.requestFullscreen) {
                        enterFallback();
                        return;
                    }

                    try {
                        await sceneWrapper.requestFullscreen();
                    } catch (error) {
                        enterFallback();
                    }
                };

                retryFullscreenToggle.addEventListener('click', handleToggle);

                document.addEventListener('fullscreenchange', () => {
                    const isSceneFullscreen = document.fullscreenElement === sceneWrapper;
                    fallbackFullscreen = false;
                    applyFullscreenClass(isSceneFullscreen);
                    resizeAfterTransition(750);
                });
            }
        }, 1000);
    }
})